import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import Movies from "@/pages/movies/page";
import MovieDetail from "@/pages/movies/detail/page";
import Actors from "@/pages/actors/page";
import ActorDetail from "@/pages/actors/detail/page";
import About from "@/pages/about/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/movies",
    element: <Movies />,
  },
  {
    path: "/movies/detail/:id",
    element: <MovieDetail />,
  },
  {
    path: "/actors",
    element: <Actors />,
  },
  {
    path: "/actors/detail/:id",
    element: <ActorDetail />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;